(() => {
  const OFFER_ROOT = '#ft-qb-offer';
  const OFFER_RADIO = 'input[type="radio"][name^="ft-qboffer-"][name$="-radio"]';

  // Dentro del tier (label del radio) viven los grupos #1..#N
  const VARIANT_BTN = '.ft-variant__btn';
  const VARIANT_OPT = '.ft-variant__option';

  const log = (...a) => console.log('[Fether Sync]', ...a);
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  function getOfferRoot() {
    return document.querySelector(OFFER_ROOT) || document;
  }

  function getCheckedTierRadio() {
    const root = getOfferRoot();
    return root.querySelector(`${OFFER_RADIO}:checked`);
  }

  function getTierLabelFor(radio) {
    if (!radio?.id) return null;
    return document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
  }

  function getBtnValue(btn) {
    const t = (btn?.getAttribute('title') || '').trim();
    if (t) return t;
    return (btn?.querySelector('span')?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Encuentra el “panel” visible donde aparecen las opciones (.ft-variant__option)
  async function waitForVisibleOptions(timeout = 2000) {
    const t0 = Date.now();
    while (Date.now() - t0 < timeout) {
      const opt = Array.from(document.querySelectorAll(VARIANT_OPT))
        .find(el => el.offsetParent !== null); // visible-ish
      if (opt) return opt.closest('[role="dialog"], .modal, .ft-modal, body') || document;
      await sleep(30);
    }
    return null;
  }

  function pickOption(panel, wantedText) {
    const want = (wantedText || '').trim();
    if (!want) return false;

    const opts = Array.from(panel.querySelectorAll(VARIANT_OPT))
      .filter(o => o.offsetParent !== null && !o.disabled);

    // match por value o por label cercano
    let target =
      opts.find(o => (o.value || '').trim() === want) ||
      opts.find(o => (o.closest('label')?.textContent || '').replace(/\s+/g,' ').trim() === want) ||
      opts.find(o => (o.closest('label')?.textContent || '').replace(/\s+/g,' ').includes(want));

    if (!target) return false;

    if (!target.checked) target.click();
    target.dispatchEvent(new Event('input', { bubbles: true }));
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function findConfirmButton(panel) {
    const buttons = Array.from(panel.querySelectorAll('button'));
    // intentamos por texto típico
    return buttons.find(b => /choose|confirm|apply|guardar|aceptar|seleccionar/i.test(b.textContent || '')) || null;
  }

  async function applyValueToButton(btn, value) {
    if (getBtnValue(btn) === value) return true;

    btn.click();

    const panel = await waitForVisibleOptions();
    if (!panel) {
      log('No aparecieron opciones al abrir un grupo (no encontré .ft-variant__option visible).');
      return false;
    }

    const ok = pickOption(panel, value);
    if (!ok) {
      log('Este grupo no tiene la opción:', value, '(btn data-key=', btn.getAttribute('data-key'), ')');
      return false;
    }

    const confirm = findConfirmButton(panel);
    if (confirm) confirm.click();

    await sleep(120);
    return true;
  }

  let syncing = false;

  async function syncAllToMaster() {
    if (syncing) return;
    syncing = true;

    try {
      const tierRadio = getCheckedTierRadio();
      const tierLabel = getTierLabelFor(tierRadio);

      if (!tierRadio || !tierLabel) {
        log('No pude detectar tier seleccionado o su label.');
        return;
      }

      // Buscamos todos los botones de variante dentro del label del tier
      const btns = Array.from(tierLabel.querySelectorAll(VARIANT_BTN));
      const master = btns.find(b => b.getAttribute('data-key') === '0') || btns[0];

      if (!master) {
        log('No encontré botón master (#1) dentro del tier.');
        return;
      }

      const masterValue = getBtnValue(master);
      if (!masterValue) return;

      const others = btns.filter(b => b !== master);
      log('Tier value=', tierRadio.value, 'Master=', masterValue, '→ syncing', others.length, 'grupos');

      for (const b of others) {
        await applyValueToButton(b, masterValue);
      }
    } finally {
      syncing = false;
    }
  }

  function armMasterWatcher() {
    const tierRadio = getCheckedTierRadio();
    const tierLabel = getTierLabelFor(tierRadio);
    if (!tierRadio || !tierLabel) return;

    const btns = Array.from(tierLabel.querySelectorAll(VARIANT_BTN));
    const master = btns.find(b => b.getAttribute('data-key') === '0') || btns[0];
    if (!master || master.__watched) return;

    master.__watched = true;
    let last = getBtnValue(master);

    new MutationObserver(async () => {
      const now = getBtnValue(master);
      if (now && now !== last) {
        last = now;
        await syncAllToMaster();
      }
    }).observe(master, { attributes: true, childList: true, subtree: true });

    log('Activo – watcher en #1 del tier seleccionado 👑');
  }

  // Re-armar cuando cambia el tier (radio) o cuando re-renderiza
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t instanceof HTMLInputElement && t.matches(OFFER_RADIO)) {
      setTimeout(() => {
        armMasterWatcher();
        // si querés: al cambiar tier, también forzamos sync inicial
        // syncAllToMaster();
      }, 0);
    }
  }, true);

  armMasterWatcher();
  new MutationObserver(() => armMasterWatcher())
    .observe(document.documentElement, { childList: true, subtree: true });

})();
